export default __webpack_public_path__ + "static/media/rusbath2.3020ea44.jpeg";